import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import { IBreakPoint } from '../../_interfaces/IBreakPoint';
import { ApplicationStore } from '../../_stores/ApplicationStore';
import * as styles from '../../styles/styleObjects';

import InfiniteScroll from 'react-infinite-scroller';

export interface IProps<T> extends RouteComponentProps<any> {
    breakPoint: IBreakPoint;
    containerWidth: number;
    content: Array<any>;
    renderItem(item: T, index: number): JSX.Element;
    store?: ApplicationStore;
    isSquareContent?: boolean;
    bottomPadding?: number;
    keyExtractor?(item: T): string | number;
}

@inject('store')
@observer
class GridItemsClass<T> extends React.Component<IProps<T>> {
    private getGridItemStyle(): React.CSSProperties {
        const columnCount: number = this.props.breakPoint.columnCount;
        const height: number = this.props.breakPoint.itemHeight;
        const spacing: number = this.props.breakPoint.itemSpacing;
        const width: number = this.props.containerWidth / columnCount - 2;

        return {
            width: width - spacing * 2,
            height: (this.props.isSquareContent ? width : height) - spacing * 2,
            margin: spacing
        };
    }

    public render() {
        const gridItemStyle = this.getGridItemStyle();
        if (this.props.content.length === undefined) {
            return null;
        }

        return (
            <div style={styles.fullContainer}>
                <div className="flex-wrap" style={styles.gridItemMapContainer}>
                    {this.props.content.map((item, index) => {
                        return (
                            <div key={this.props.keyExtractor ? this.props.keyExtractor(item) : index} style={gridItemStyle}>
                                {this.props.renderItem(item, index)}
                            </div>
                        );
                    })}
                    {/*<div style={{ height: this.props.bottomPadding, width: '100%' }} />*/}
                </div>
            </div>
        );
    }
}

export const GridItems = withRouter(GridItemsClass);



// WEBPACK FOOTER //
// ./src/SharedComponents/GridDisplay/GridItems.tsx